import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FieldFilters } from '../../_models/preferences';

@Injectable({
  providedIn: 'root'
})
export class FieldFilterService {
  private currentYear: string;

  constructor(private router: Router, private route: ActivatedRoute) { }

  resetFilters(): FieldFilters {
    let cleanfilter: FieldFilters = new FieldFilters;
    cleanfilter.selectedBatteries = []
    cleanfilter.selectedTanks = [];
    cleanfilter.fieldQuery = null;
    cleanfilter.runTicketQuery = null;

    return cleanfilter;
  }

  clearFilterParamsFromRoute() {
    const updatedParams: Params = {
      'battery': null,
      'tank': null,
      'query': null
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: updatedParams,
        queryParamsHandling: 'merge'
      }
    );
  }
}
